import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcPause(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 3.25a2.625 2.625 0 0 0-2.625 2.625v12.25a2.625 2.625 0 0 0 5.25 0V5.875A2.625 2.625 0 0 0 8 3.25M6.875 5.875a1.125 1.125 0 0 1 2.25 0v12.25a1.125 1.125 0 0 1-2.25 0zM16 3.25a2.625 2.625 0 0 0-2.625 2.625v12.25a2.625 2.625 0 0 0 5.25 0V5.875A2.625 2.625 0 0 0 16 3.25m-1.125 2.625a1.125 1.125 0 0 1 2.25 0v12.25a1.125 1.125 0 0 1-2.25 0z",
    clipRule: "evenodd"
  }));
}
var IcPause = createNolIcon(/*#__PURE__*/forwardRef(SvgIcPause));

export { IcPause as I };
